import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'

import TextButton from 'LuxKit/Button/TextButton'
import FooterWithCreateUpdateInfo from 'tripPlanner/components/TripModal/Common/FooterWithCreateUpdateInfo'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'
import type { TripItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: TripItem
}

export default function ReadOnlyItemFooter({ item }: Props) {
  const intl = useIntl()
  const { closeModal } = useModalCallbacks()

  const onClose = useCallback(() => {
    closeModal()
  }, [closeModal])

  const doneLabel = intl.formatMessage({
    id: 'BhxzWJHQ2m',
    defaultMessage: 'Done',
    description: 'Button text to close the read-only trip item summary modal',
  })

  return (
    <FooterWithCreateUpdateInfo item={item}>
      <TextButton size="large" kind="primary" onClick={onClose}>
        {doneLabel}
      </TextButton>
    </FooterWithCreateUpdateInfo>
  )
}
